/**
 * 종목 관리 API
 * OpenAPI Generator로 생성된 타입을 사용하며, 기존 Axios 인스턴스와 통합
 */
export class StockService {
    constructor(axiosInstance) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axiosInstance;
    }
    /**
     * 주문 정보 조회
     * 종목의 주문 관련 정보를 확인할 수 있다.
     * @param stockCode - 종목 코드
     * @returns 주문 정보 조회 결과
     */
    getOrderInfo(stockCode) {
        return this.axios.get(`/main/v1/stocks/${stockCode}/order-info`);
    }
    /**
     * 스프레드 그룹 조회
     * 스프레드 그룹 정보를 확인할 수 있다.
     * @returns 스프레드 그룹 조회 결과
     */
    getSpreadGroups() {
        return this.axios.get(`/main/v1/stocks/spread-groups`);
    }
    /**
     * 보유종목 조회
     * 종목의 보유종목을 확인할 수 있다.(홈화면)
     * @param request - 보유종목 조회 요청 데이터
     * @returns 보유종목 조회 결과
     */
    getPossessionStocks(request) {
        return this.axios.get(`/main/v1/stocks/possessions`, {
            params: request,
        });
    }
    /**
     * 주문잔고 조회
     * 종목의 주문잔고를 확인할 수 있다.(홈화면)
     * @param request - 주문잔고 조회 요청 데이터
     * @returns 주문잔고 조회 결과
     */
    getPositionStocks(request) {
        return this.axios.get(`/main/v1/stocks/positions`, {
            params: request,
        });
    }
    /**
     * 주문잔고 조회(전체)
     * 종목의 주문잔고를 확인할 수 있다.(홈화면)
     * @param request - 주문잔고 조회(전체) 요청 데이터
     * @returns 주문잔고 조회(전체) 결과
     */
    getAllPositionStocks(request) {
        return this.axios.get(`/main/v1/stocks/positions/all`, {
            params: request,
        });
    }
    /**
     * 주문종목 조회
     * 종목의 MetaData 를 확인할 수 있다.(홈화면, 종목쪽 조회 등 쓰임)
     * @param request - 주문종목 조회 요청 데이터
     * @returns 주문종목 조회 결과
     */
    getOrderStocks(request) {
        return this.axios.get(`/main/v1/stocks/orders`, {
            params: request,
        });
    }
    /**
     * 계좌종목 조회
     * 계좌에 속한 종목과 증거금율을 조회할 수 있다.
     * @param request - 계좌종목 조회 요청 데이터
     * @returns 계좌종목 조회 결과
     */
    getAccountStocks(request) {
        return this.axios.get(`/main/v1/stocks/accounts`, {
            params: request,
        });
    }
}
//# sourceMappingURL=stock.service.js.map